import {
  IAddComponentsToJobPayload,
  IComponent,
  IComponentAutocompleteRequestPayload,
  IUpsertBomComponentPayload,
  IUpsertBomComponentsPayload,
} from 'bom/types';
import { formatElementApiKey } from 'bom/utils';
import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { getQueryStringToSnakeCase } from 'core/utils';

export const getComponentsAutocomplete = async (
  requestPayload?: IComponentAutocompleteRequestPayload,
  signal?: AbortSignal
) => {
  const { data } = await partfinitiClient.get(
    `/bom/component/autocomplete?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IComponent>(data.components, data.total_count);
};

export const upsertBomComponent = async (data: IUpsertBomComponentPayload) =>
  partfinitiClient.postForm('/bom/component/save', data, {
    includeNullValues: true,
    toSnakeCase: formatElementApiKey,
  });

export const upsertBomComponents = async (data: IUpsertBomComponentsPayload) =>
  partfinitiClient.postForm('/bom/component/save-bulk', data, {
    includeNullValues: true,
    toSnakeCase: formatElementApiKey,
  });

export const removeBomComponents = async (ids: number[]) =>
  partfinitiClient.postForm('/bom/component/remove', { ids });

export const restoreBomComponents = async (ids: number[]) =>
  partfinitiClient.postForm('/bom/component/restore-deleted', { ids });

export const removeComponentFromPart = async (ids: number[]) =>
  partfinitiClient.postForm('/bom/component/remove-from-part', { ids });

export const addComponentsToJob = async (data: IAddComponentsToJobPayload) =>
  partfinitiClient.postForm('/bom/component/copy-components-to-bom', data);
